import React, { Component } from "react";
import Common from "../constants/common";

class CopyToClipboard extends Component {
    handleCopyToClipboard = event => {
        const { text } = this.props;
        event.stopPropagation();
        Common._copyToClipBoard(text);
    };

    render() {
        const { data_placement } = this.props;
        return (
            <div
                onClick={this.handleCopyToClipboard}
                style={{ cursor: "text" }}
                data-tip="Copy to clipboard"
                data-class="tooltipStyleClass"
                data-place={data_placement}
            >
                {this.props.children}
            </div>
        );
    }
}

export default CopyToClipboard;
